import { useQuery } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { getSmsCampaignInformation } from 'services';
import { SMS_CAMPAIGN_INFO_KEY } from '../constants';

export function useGetSMSCampaignInfo() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;

  return useQuery([SMS_CAMPAIGN_INFO_KEY], {
    queryFn: () => getSmsCampaignInformation(corpAcctNbr, true),
    enabled: !!corpAcctNbr,
    onError: (e) => {
      // eslint-disable-next-line no-console
      console.error('Error in getSmsCampaignInformation', e);
    },
  });
}
